import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslation from "./locales/en/translation.json"; // Doğru dosya yolunu verin
import azTranslation from "./locales/az/translation.json"; // Doğru
import ruTranslation from "./locales/ru/translation.json"; // Doğru


const resources = {
  az: {...azTranslation,
  },
  en: { ...enTranslation,
  },
  ru: {...ruTranslation,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', 
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n



// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// // import translateAz from './translateAz.json'
// // import translateRu from './translateRu.json'
// // import translateTr from './translateTR.json'
// // import translateEn from './translateEn.json'


// const resources = {
//   az: {...azTranslation},
//   ru: {...ruTranslation},
//   en: {...enTranslation}
// }


// void i18n
//   .use(initReactI18next)
//   .init({
//     resources,
//     lng: 'az',
//     fallbackLng: 'az',
//     debug: true,
//     interpolation: {
//       escapeValue: false
//     }
//   });

// export default  i18n